// Repair capabilities shared by the admin console (tick boxes) and the
// customer map filter. Keys are stored on each repairer; labels are shown.
export const CAPABILITIES = [
  { key: "mobile", label: "Mobile service" },
  { key: "renogy", label: "Renogy agent" },
  { key: "electrical", label: "Electrical / 12V" },
  { key: "chassis", label: "Chassis & suspension" },
  { key: "plumbing", label: "Plumbing & water" },
  { key: "gas", label: "Gas & hot water" },
  { key: "appliances", label: "Appliances (fridge / A-C)" },
  { key: "body", label: "Body & panel" },
  { key: "warranty", label: "Warranty repairs" },
];

export const capLabel = (key) =>
  CAPABILITIES.find((c) => c.key === key)?.label || key;
